module.exports = __webpack_public_path__ + "static/media/golfer-5-a.0f4e3e33.png";